module.exports = __webpack_public_path__ + "img/box_bg.87a812c8.png";